import { render, staticRenderFns } from "./setDetailOption.vue?vue&type=template&id=03c5022a&scoped=true&"
import script from "./setDetailOption.vue?vue&type=script&lang=js&"
export * from "./setDetailOption.vue?vue&type=script&lang=js&"
import style0 from "./setDetailOption.vue?vue&type=style&index=0&id=03c5022a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5022a",
  null
  
)

export default component.exports